<template>
  <div
    class="section-row"
    id="caterina"
  >
    <h1 class="section-title text-center mb-10">Caterina Bueno</h1>
    <hr class="customhr">
    <div class="section-text">
      <p>
        Il lavoro di ricerca della cantante italiana Caterina Bueno (1943-2007) è stato molto apprezzato per il suo valore culturale, in quanto ha permesso la raccolta di molte canzoni popolari toscane e dell'Italia centrale. Ha iniziato a viaggiare attraverso la campagna e i paesi toscani registrando contadini, artigiani, uomini e donne comuni toscani che cantano qualsiasi tipo di canzone popolare: ninne nanne, ottave (stanze in rima cantate durante contrasti improvvisati tra poeti), stornelli (canzoni monostrofiche), canzoni narrative, social e canzoni politiche, e molto altro. In Caterina Bueno coesisteva il rispetto filologico per le fonti con il senso del dovere verso l’estetica del canto. Richiamando il parallelo usato da Pietro Clemente (2014), l’attività di Caterina Bueno può essere sintetizzata con le parole del museografo ed etnografo Ettore Guatelli: “Tutti sono capaci di fare un museo con le cose belle, più difficile è crearne uno bello con le cose umili come le mie”. In altre parole, per Caterina Bueno il successo della trasmissione di una tradizione popolare è determinato dalla bontà del suo arrangiamento estetico.
      </p>
    </div>
    <hr>
    <h3>L'archivio di Caterina Bueno</h3>
    <div class="section-text">
      <p>
        L'archivio sonoro di Caterina Bueno è composto da 476 supporti (bobine audio e cassette compatte), corrispondenti a quasi 714 ore di registrazione ed è stato digitalizzato durante il progetto PAR-FAS Gra.fo (
        <a
          href="http://grafo.sns.it/"
          target="_blank"
          rel="noopener noreferrer"
        >Grammo-foni. Le soffitte della voce</a>
        , UNISI & SNS, 2007-2013). Si trovava presso due diversi proprietari: parte di esso era conservato nella casa degli eredi di Caterina, mentre il resto era custodito dall'assessore per la Cultura del Comune di San Marcello Pistoiese. Diviso in due parti, l'archivio era frammentato e inaccessibile alla comunità. Entrambi i proprietari si sono messi in contatto con Silvia Calamai (UNISI) affinché l’archivio fosse riassemblato e messo a disposizione della comunità di ricerca, rispettando così le volontà di Caterina. L'archivio è organizzato secondo le seguenti serie:
      </p>
      <ul>
        <li>Concerti (le performance “pubbliche” di Caterina e dei suoi musicisti: 73 unità documentali)</li>
        <li>Prove (di concerti, di interventi radiofonici o televisivi e di spettacoli teatrali: 188 unità documentali)</li>
        <li>Ricerca sul campo (indagini condotte nella campagna toscana dai tardi anni '50 alla fine della vita dell'artista: 97 unità documentali)</li>
        <li>Interviste (fatte a Caterina Bueno o ad altri e conservate nell’archivio: 7 unità documentali)</li>
        <li>Convegni (con Caterina Bueno come relatrice o su temi pertinenti alle sue attività: 4 unità documentali)</li>
        <li>Musica e teatro (registrazioni di musica di vario genere e performance teatrali: 136 unità documentali)</li>
        <li>Compilazioni (di brani musicali di vario genere create da o per Caterina Bueno: 15 unità documentali)</li>
        <li>Trasmissioni radiofoniche (condotte da Caterina Bueno, dai suoi collaboratori o di altro genere: 5 unità documentali)</li>
      </ul>
      <p>
        Nel 2021 Archivio Vi.Vo. ha recuperato 15 ulteriori bobine dell’Archivio Bueno. Questi materiali, precedentemente dati per dispersi, aggiungeranno un altro tassello alla ricostruzione dell’opera della cantante toscana.
      </p>
    </div>
    <img
      src="../assets/images/supportiavivo.jpg"
      class="rounded d-block section-img-center"
    >
    <h3>Il Caso di Studio</h3>
    <div class="section-text">
      <p>
        Nel 2010, la famiglia Bueno ha depositato l'archivio di Caterina contenente articoli, lettere, note, disegni, fotografie, materiali di ricerca presso l'Archivio di Stato di Firenze. Il materiale è stato catalogato (
        <a
          href="http://www.consiglio.regione.toscana.it/upload/eda/pubblicazioni/pub4013.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >Giorgi et al. 2014</a>
        ), ma l'archivio è «silenzioso»: non consente di ascoltare la voce di Caterina e dei suoi informatori. Archivio Vi.Vo. colmerà il divario tra le carte di Caterina Bueno e la sua voce.
        L’Archivio sonoro Caterina Bueno è il banco di prova per saggiare la validità dei principi e delle procedure concepiti nell’ambito del progetto Archivio Vi.Vo. La gestione dell’Archivio Bueno può essere considerato un vero e proprio
        <em>stress test</em>
        per la piattaforma in via di sviluppo considerati i suoi molteplici elementi di complessità:
      </p>
      <ul>
        <li>La sua articolata storia archivistica</li>
        <li>Lo stato di conservazione non ottimale dei supporti</li>
        <li>L’estrema eterogeneità dei materiali audio contenuti dall’archivio</li>
        <li>La complessa gestione della componente legale</li>
      </ul>
      <p>
        Le conoscenze generate nel processo di trattamento dell’Archivio Bueno rimarranno a modello dei criteri di metadatazione, restauro audio, descrizione dei materiali e tutela legale alla base di Archivio Vi.Vo.
      </p>
    </div>
  </div>
</template>